import { FC } from 'react';
import { Input } from 'antd';
import type { TextAreaProps } from 'antd/es/input';

const { TextArea } = Input;

const STextArea: FC<TextAreaProps> = (props) => {
  return <TextArea {...props} />;
};

export default STextArea;
